function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#prefix__clip0_92_5084)",
  stroke: "#969799"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.987 12.462a4.5 4.5 0 018.025 0m1.913-5.406a6 6 0 11-4.981-4.981",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.241 2.82h-3.158v1.93h3.158V2.82zm-2.456 0v-.526a.877.877 0 111.754 0v.526",
  strokeWidth: ".8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__clip0_92_5084"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));